import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const NotFound = ({ message, showHomeLink = true }) => {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-6 text-center py-5">
          <div className="not-found-wrapper">
            <i
              className="far fa-exclamation-circle mb-4"
              style={{ fontSize: '4rem', color: 'var(--theme-color)' }}
            ></i>
            <h2 className="h4 mb-4">{message || 'Content Not Found'}</h2>
            {showHomeLink && (
              <Link to="/" className="th-btn">
                Back to Home <i className="fas fa-arrow-right ms-2"></i>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

NotFound.propTypes = {
  message: PropTypes.string,
  showHomeLink: PropTypes.bool,
};

export default NotFound;
